import { toString, isNaN } from 'lodash';

export const normalizeNumber = (value) => {
  if (!value) {
    return value;
  }
  const numbers = toString(value).replace(/[^\d]/g, '');
  return numbers;
};

export const normalizeNumberRange0to100 = (value) => {
  let number = parseInt(normalizeNumber(value), 10);
  if (number >= 100) {
    number = 100;
  }
  if (number <= 0 || isNaN(number)) {
    number = 0;
  }
  return toString(number);
};

export const unitRender = (n, digits = 2) => (n ? n.toLocaleString(
  // Need to use German because Icelandic is not working
  'de-DE',
  { maximumFractionDigits: digits, minimumFractionDigits: digits },
) : n);



// WEBPACK FOOTER //
// ./src/utils/normalize.js